import React from 'react'

const GENERIC_ERROR = 'Sorry we are unable to process your request at this time. Please try again later.'

const JoraSignUpForm = React.createClass({
  getInitialState: function() {
    return {
      email: '',
      password: '',
      category: (this.props.category == undefined) ? '' : this.props.category.name,
      category_id: (this.props.category == undefined) ? null : this.props.category.id,
      suburb:  (this.props.suburb == undefined) ? null : this.props.suburb.name,
      suburb_id: (this.props.suburb == undefined) ? null : this.props.suburb.id,
      first_name: '',
      business_name: '',
      contact_phone: '',
      showPassword: false,
      existingUser: false,
      errorMessage: '',
      loading: false,
      secondStep: false,
      originId: null
    }
  },

  componentDidMount: function() {
    let $signUpForm1 = $('#signup-form1');
    let $signUpForm2 = $('#signup-form2');

    $signUpForm1.on('submit', (e) => { e.preventDefault() })
    $signUpForm2.on('submit', (e) => { e.preventDefault() })

    this.setupValidationForm1()
  },

  setupValidationForm1: function() {
    $('#signup-form1').bootstrapValidator({
      fields: {
        email_address: {
          verbose: false,
          validators: {
            notEmpty: {
              message: 'Please enter an email address'
            },
            emailAddress: {
              message: 'Please enter a valid email address'
            },
            blank: {}
          }
        },

        first_name: {
          validators: {
            notEmpty: {
              message: 'Please enter your first name'
            }
          }
        }
      }
    })

    this.validator1 = $('#signup-form1').data('bootstrapValidator')
  },

  setupValidationForm2: function() {
    $('#signup-form2').bootstrapValidator({
      fields: {
        business_name: {
          validators: {
            notEmpty: {
              message: 'Please enter your business name'
            },
            blank: {}
          }
        },

        contact_phone: {
          verbose: false,
          threshold: 9999,
          validators: {
            notEmpty: {
              message: 'Please enter your contact number'
            },

            stringLength: {
              min: 10,
              max: 10,
              message: 'Number should be 10 digits long.'
            },

            regexp: {
              regexp: /^((?!(1300|1800)))/i,
              message: 'Please enter a valid mobile or landline number.'
            },

            remote: {
              data: function (validator) {
                return {
                  signup: {
                    user_attributes: {
                      contact_phone: validator.getFieldElements('contact_phone').val()
                    }
                  }
                }
              },
              message: 'Invalid number.',
              url: '/businesses/signup/validate_contact_phone',
              type: 'GET'
            }
          }
        },

        password: {
          validators: {
            notEmpty: {
              message: 'Please enter a password'
            },
            stringLength: {
              min: 8,
              max: 128,
              message: 'Please ensure your password is at least 8 characters'
            },
            blank: {}
          }
        },

        newsletter: {
          validators: {
            notEmpty: {
              message: 'Please agree to the Terms & Conditions to continue'
            }
          }
        }
      }
    })

    this.validator2 = $('#signup-form2').data('bootstrapValidator')
  },

  handleRegisterButton: function() {
    this.validator1.validate()

    if (this.validator1.isValid()) {    
      this.signUp()
    }
  },

  handleCompleteButton: function() {
    if (this.validator2.isValid()) {
      this.setState({ errorMessage: '' })
      this.register()
    }
  },

  emailFormat: function() {
    let $field = $('#email_address')

    if ($('#email_address').val().length > 0) {
      let formattedEmailAddress = $field.val().replace(/[\s]/g, '')

      if ($field.val() !== formattedEmailAddress){
        $field.val(formattedEmailAddress)
      }

      this.setState({ email: formattedEmailAddress })
    }
  },

  signUp: function() {
    if (this.state.email.length > 0) {
      $.ajax($.extend(SS.API.V3.userCheckEmail(this.state.email), {
        beforeSend: () => {
          this.setState({ loading: true })
        }
      })).fail(function () {
        document.location = "/500"
      }).done((response) => {
        const data = response.meta

        if (data.status === 'true') {
          this.setState({ loading: false, existingUser: true })
          this.validator1.updateMessage('email_address', 'blank', "You're already registered. Click <a href='/users/sign_in' className='text-blue'>here</a> to login")
          this.validator1.updateStatus('email_address', 'INVALID', 'blank')
        } else if (data.status === 'valid') {
          this.validator1.destroy()
          document.getElementById('signup-form1').reset();
          this.setState({ loading: false, secondStep: true }, function() {
            this.setupValidationForm2()
            $('#business_name').focus()
          })
        } else if (data.status === 'invalid') {
          this.validator1.updateMessage('email_address', 'blank', data.error || 'Please enter a valid email address.')
          this.validator1.updateStatus('email_address', 'INVALID', 'blank')
        }
      })
    }
  },

  register: function() {
    let registration = {
      category_id: this.state.category_id,
      suburb_id: this.state.suburb_id,
      name: this.state.first_name,
      business_name: this.state.business_name,
      contact_phone: this.state.contact_phone,
      email: this.state.email,
      password: this.state.password,
      password_confirmation: this.state.password
    }

    if (/[?&]origin=jora/.test(location.search)) {
      registration.origin_name = 'jora'
    }

    $.ajax({
      url: '/list-your-business/registrations',
      method: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'), 'Accept': 'application/json' },
      data: JSON.stringify({ registration: registration }),
      beforeSend: () => {
        this.setState({ loading: true })
      }
    })
      .done((result, _status, xhr) => {
        if (xhr.status !== 201) {
          window.location.href = result.redirect_to
          return
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ event: 'custom.event.businessSignUp' });

        if (this.isProdSite()){
          this.submitToHubSpot(result.redirect_to, result.business_id, result.user_id)
        }
        else {
          window.location.href = result.redirect_to
        }
      })
      .fail((xhr) => {
        const body = xhr.responseJSON || {}
        this.handleRegistrationErrors(xhr.status === 422 && body.errors ? body.errors : {})
      })
  },

  handleRegistrationErrors: function(errors) {
    const nameErrors = errors.businessName || []
    const otherErrors = Object.keys(errors)
      .filter((field) => field !== 'businessName')
      .map((field) => errors[field][0])
    const refused = nameErrors.length > 0 || otherErrors.length > 0

    this.setState({ loading: false, errorMessage: refused ? otherErrors.join(' ') : GENERIC_ERROR }, () => {
      if (nameErrors.length > 0) {
        this.validator2.updateMessage('business_name', 'blank', nameErrors[0])
        this.validator2.updateStatus('business_name', 'INVALID', 'blank')
      }
    })
  },

  handleBusinessNameOnChange: function(e) {
    this.setState({ business_name: e.target.value }, () => { this.validator2.updateStatus('business_name', 'VALID', 'blank') })
  },

  isProdSite: function() {
    const currentUrl = window.location.href
    if (currentUrl.indexOf('https://www') == 0) return true
    return false
  },

  submitToHubSpot(url, businessId, userId) {
   $.ajax({
      url: `https://api.hsforms.com/submissions/v3/integration/submit/23226544/b159c3f4-31b7-48c4-b526-32383cc80751`,
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        "submittedAt": new Date().getTime().toString(),
        "fields": [
          {
            "objectTypeId": "0-1",
            "name": "email",
            "value": this.state.email
          },
          {
            "objectTypeId": "0-1",
            "name": "firstname",
            "value": this.state.first_name
          },
          {
            "objectTypeId": "0-1",
            "name": "business_id",
            "value": businessId
          },
          {
            "objectTypeId": "0-1",
            "name": "user_id",
            "value": userId
          }
        ],
        "context": {
          "pageUri": window.location.href,
          "pageName": "List Your Business page"
        },
        "legalConsentOptions": {
          "consent": {
            "consentToProcess": true,
            "text": "I agree to allow ServiceSeeking to store and process my personal data.",
            "communications": [
              {
                "value": true,
                "subscriptionTypeId": 999,
                "text": "I agree to receive marketing communications from ServiceSeeking."
              }
            ]
          }
        }
      }),
      success: function(){
        window.location.href = url
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        window.location.href = url
      }
    })
  },

  revalidateField: function(field) {
    $('#signup-form2').data('bootstrapValidator').revalidateField(field)
  },

  formatContactNumber: function(e) {
    let $field = e.currentTarget
    $field.value = $field.value.replace(/[^\d]/g, "").replace(/(^61)+/g, "0")
    this.setState({ contact_phone: $field.value }, () => { this.revalidateField('contact_phone') })
  },

  handleShowPassword: function() {
    this.setState({showPassword: !this.state.showPassword})
  },

  handlePasswordOnChange: function (e) {
    this.setState({ password: e.target.value }, () => { this.validator2.updateStatus('password', 'VALID', 'blank') })
  },

  errorMessages() {
    if (this.state.errorMessage.length > 0) {
      return (
        <div className="alert alert-danger mt20 mb0">{this.state.errorMessage}</div>
      )
    }
  },

  render() {
    return(
      <div id='business-signup'>  
        <div className="col-xs-12 p0 pb48">
          { this.state.secondStep ?
            <div>
              <form id="signup-form2" className="mt10">
                <div className="form-group">
                  <span className="font-16">Business Name</span>
                  <input type="text" className="form-control" name="business_name" id="business_name"
                    autoComplete="organization" value={this.state.business_name}
                    onChange={this.handleBusinessNameOnChange} />
                </div>
                <div className="form-group">
                  <span className="font-16">Phone Number</span>
                  <input type="text" className="form-control" name="contact_phone" id="contact_phone" defaultValue={this.state.contact_phone}
                    autoComplete="off" onBlur={this.formatContactNumber} />
                </div>
                <div className="form-group">
                  <span className="font-16">Password</span>
                  <div className="input-group">
                    <input
                      type={this.state.showPassword ? `text` : `password`}
                      className="form-control"
                      name="password"
                      id="password"
                      autoComplete="new-password"
                      value={ this.state.password }
                      onChange={ this.handlePasswordOnChange }
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-default"
                        type="button"
                        style={{width: '80px'}}
                        onClick={this.handleShowPassword}>{this.state.showPassword ? `HIDE` : `SHOW`}
                      </button>
                    </span>
                  </div>
                </div>
                {this.errorMessages()}
                <div className="form-group mb0 mt30">
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" name="newsletter" id="ss-update" />
                      I agree to the <a className='no-wrap' href='https://www.serviceseeking.com.au/blog/terms-and-conditions/' target='_blank'>Terms & Conditions </a> 
                      and to receive lead alerts and marketing messages by SMS & email.
                    </label>
                  </div>
                </div>
                {
                  this.state.loading ?
                  <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
                  :
                  <div className="form-group mt20">
                    <input type="submit"
                      name="commit"
                      value="Complete Your Registration"
                      className="btn btn-main btn-block text-white"
                      onClick={this.handleCompleteButton}
                    />
                  </div>
                }
              </form>
            </div>
            :
            <div>
              <form id="signup-form1" className="mt10">
                <div className="form-group">
                  <span className="font-16">Your Name</span>
                  <input type="text" className="form-control" name="first_name" id="first_name" autoComplete="off"
                    onChange={ (e) => { this.setState({ first_name: e.target.value }) } }
                  />
                </div>
                <div className="form-group">
                  <span className="font-16">Email Address</span>
                  <input type="text" className="form-control" id="email_address"
                    name="email_address"
                    onBlur={this.emailFormat}
                  />
                </div>
                {this.errorMessages()}
                { this.state.loading ?
                  <div className="spinner-icon text-center" style={{marginLeft: '15px'}}/>
                  :             
                  <div className="form-group mt20">
                    <input type="submit"
                      name="commit"
                      value="Register Your Interest"
                      className="btn btn-main btn-block text-white"
                      onClick={this.handleRegisterButton}
                    />
                  </div>
                }
              </form>
            </div> 
          }      
        </div>
      </div>
    )
  }
})

export default JoraSignUpForm
